import { MinzeElement, Reactive, EventListeners, Attrs } from 'minze'
import { MODALS } from '../../../constants'
import MainModule from '../../../modules/main'
import {
  AbstractSubscriber,
  AbstractSearchCore,
  IFacet,
  IFacetOption,
  ISearchConfig,
} from '../../../modules/search'
import { Locale } from '../../../modules/locale'
import { Font } from '../../../constants'
import { Callback } from '../../../modules/callback'

Locale.getInstance().registerKeySet('fr', 'hasEventsFilter', {
  labelPlace: 'Inclure les lieux sans événements actifs',
  labelArtist: 'Inclure les artistes et organisations sans événements actifs',
})

Locale.getInstance().registerKeySet('en', 'hasEventsFilter', {
  labelPlace: 'Include venues without active events',
  labelArtist: 'Include artists and organizations without active events',
})

class LvcHasEventsSubscriber extends AbstractSubscriber {
  _core: AbstractSearchCore | null = null
  private _callback: (...args: any[]) => void

  constructor(groupId: string, callback: (...args: any[]) => void) {
    super(groupId)
    this._callback = callback
  }

  public async attached(core: AbstractSearchCore): Promise<void> {
    this._core = core
  }

  public detaching(): void {
    this._core = null
  }

  async onSearchTextUpdate(text: string): Promise<void> {}
  async onResultUpdate(results: any): Promise<void> {}
  async onFacetUpdate(facets: IFacet[]): Promise<void> {}

  async onSearchConfigUpdate(config: ISearchConfig): Promise<void> {
    let facet = config?.facets?.find(facet => facet.name === 'hasPublishedEvents')

    if (facet) {
      let option = facet.options?.find(option => option.value === 'false')

      if (option) {
        this._callback(option.selected)
        return
      }
    } else {
      config.facets?.push({
        name: 'hasPublishedEvents',
        options: [
          {
            value: 'true',
            selected: true,
          } as IFacetOption,
        ],
      })
    }
    this._core?.applySearchConfig(config, false)
    this._callback(false)
  }

  public async toggleHasEvents(toggle: boolean): Promise<void> {
    let searchConfig = this._core?.searchConfig
    if (!searchConfig) {
      searchConfig = {} as ISearchConfig
    }
    let facet = searchConfig?.facets?.find(facet => facet.name === 'hasPublishedEvents')

    if (!facet) {
      facet = {
        name: 'hasPublishedEvents',
        options: [
          {
            value: 'false',
            selected: false,
          } as IFacetOption,
        ],
      }
      searchConfig.facets?.push(facet)
    }

    let option = facet.options?.find(option => option.value === 'false')

    if (!option) {
      option = {
        value: 'false',
        selected: false,
      } as IFacetOption
      facet.options?.push(option)
    }

    option.selected = toggle
    this._core?.applySearchConfig(searchConfig)
    this._core?.goToSearch(false)
  }
}

export class LvcHasEventsSearch extends MinzeElement {
  private toggleCb: string = Callback.attach(this.onToggle.bind(this))
  private initialToggled: boolean = true
  private subscriber: LvcHasEventsSubscriber | null = null

  async onReady(): Promise<void> {
    this.subscriber = new LvcHasEventsSubscriber(
      this.dataGroupId as string,
      this.searchUpdated.bind(this)
    )
    MainModule.getInstance().getSearchManager().subscribe(this.subscriber)
    this.rerender()
  }

  async searchUpdated(toggle: boolean): Promise<void> {
    this.initialToggled = toggle
    this.rerender()
  }

  async onToggle(tgl: boolean): Promise<void> {
    this.toggled = tgl
    this.subscriber?.toggleHasEvents(tgl)

    this.rerender()
  }

  onDestroy() {
    Callback.detach(this.toggleCb)
  }

  html = () => `
      <lvc-toggle initial-toggled="${this.initialToggled ? 'true' : 'false'}" on-click="${this.toggleCb}"></lvc-toggle>
      <span class="label">
        ${this.subscriber?._core?.searchConfig.modal === 'places_full' ? Locale.getKey('hasEventsFilter.labelPlace') : Locale.getKey('hasEventsFilter.labelArtist')}
    </span>
  `

  css = () => `
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      font-size: 14px;
    }
  `
}
